import React from 'react';
import { styled } from '@stitches/react';
import AnimatedSection from '../../components/common/AnimatedSection';

// 页面标题
const MainTitle = styled('h1', {
  fontSize: '2.5rem',
  fontWeight: '700',
  color: '#fff',
  textAlign: 'center',
  margin: '0 0 2rem'
});

// 页面副标题
const PageSubtitle = styled('p', {
  fontSize: '1.2rem',
  textAlign: 'center',
  maxWidth: '800px',
  margin: '0 auto 3rem',
  color: '#e0e6ed',
  lineHeight: 1.6,
});

// 内容区块
const ContentSection = styled('div', {
  backgroundColor: '#232b39',
  borderRadius: '10px',
  padding: '2.5rem',
  marginBottom: '3rem',
  boxShadow: '0 4px 20px rgba(0, 0, 0, 0.15)',
});

// 部分标题
const SectionTitle = styled('h2', {
  fontSize: '1.75rem',
  fontWeight: '600',
  color: '#fff',
  marginBottom: '1.5rem',
  textAlign: 'center',
});

// 团队成员网格
const TeamGrid = styled('div', {
  display: 'grid',
  gridTemplateColumns: 'repeat(auto-fill, minmax(300px, 1fr))',
  gap: '2rem',
  margin: '2rem 0',
});

// 团队成员卡片
const TeamMemberCard = styled('div', {
  backgroundColor: '#232b39',
  borderRadius: '10px',
  overflow: 'hidden',
  boxShadow: '0 4px 15px rgba(0, 0, 0, 0.15)',
  transition: 'transform 0.3s ease, box-shadow 0.3s ease',
  height: '100%',
  display: 'flex',
  flexDirection: 'column',
  
  '&:hover': {
    transform: 'translateY(-5px)',
    boxShadow: '0 10px 30px rgba(0, 0, 0, 0.18)'
  }
});

// 成员照片容器
const MemberPhotoContainer = styled('div', {
  width: '100%',
  height: '0',
  paddingBottom: '75%',
  position: 'relative',
  overflow: 'hidden',
});

// 成员照片
const MemberPhoto = styled('div', {
  position: 'absolute',
  top: 0,
  left: 0,
  width: '100%',
  height: '100%',
  backgroundSize: 'cover',
  backgroundPosition: 'center',
});

// 成员信息容器
const MemberInfo = styled('div', {
  padding: '1.5rem',
  display: 'flex',
  flexDirection: 'column',
  gap: '0.5rem',
  flex: 1,
});

// 成员姓名
const MemberName = styled('h3', {
  fontSize: '1.25rem',
  fontWeight: '600',
  color: '#fff',
  marginBottom: '0.25rem',
});

// 成员职位
const MemberTitle = styled('h4', {
  fontSize: '1rem',
  color: '#6A7EFC',
  fontWeight: '500',
  marginBottom: '1rem',
});

// 成员简介
const MemberBio = styled('p', {
  fontSize: '0.9rem',
  lineHeight: 1.6,
  color: '#e0e6ed',
  flex: 1,
});

/**
 * 关于团队页面组件
 * 展示团队成员信息
 */
const AboutTeam: React.FC = () => {
  // const { t } = useTranslation(); // 暂时未使用
  
  // 团队成员数据
  const teamMembers = [
    {
      id: 1,
      name: 'Alexey Reznechenko',
      title: 'CFO',
      photo: '/images/team/alexey.jpg', // 注意: 确保图片路径正确
      bio: 'Alexey has over 20 years of experience in high-tech, service and manufacturing, B2B industries. Has held executive and management roles between finance, investor relations, sales and operations in FSU, United Kingdom and United States. Holds MBA from California State University. Most recently worked as VP financial planning and analysis at Baker Hughes covering FSU and Continental Europe. Currently works as a CFO for a Russian (Eastern Europe based) pipeline automation company.'
    },
    {
      id: 2,
      name: 'Andrey Tugarin',
      title: 'Legal Mentor',
      photo: '/images/team/andrey.jpg',
      bio: 'Education: Peoples\' Friendship University of Russia with a Master\'s degree in jurisprudence. Qualification: Civil, arbitration process. Received advanced training under the auspices of the World Intellectual Property Organization. Work experience: Member of INTA and FICPI, experience in the field of protection and protection of intellectual property since 2008. Since 2017, he has led the legal support of more than 100 blockchain projects on corporate structure, tax optimization and licensing in the USA, EU countries and Asia. Participant of significant events in the world of Fintech and Blockchain.'
    },
    {
      id: 3,
      name: 'Anton Kobak',
      title: 'CEO Kobak Lab',
      photo: '/images/team/anton.jpg',
      bio: 'Creation and development of a laboratory for the formation, development and commissioning of technological products and software. Competence in software, neural networks, mechanics and electronics. Specialization: Video analytics; Robotics; Software and hardware systems; Web applications; Medical equipment. More than 100 projects have been successfully completed. Development of 7 products that subsequently entered the market. 4 patents have been registered.'
    }
  ];
  
  return (
    <>
      <MainTitle>Our Team</MainTitle>
      
      <PageSubtitle>
        Meet the talented individuals behind BeMine who are dedicated to bringing you the most efficient and transparent mining experience.
      </PageSubtitle>
      
      <AnimatedSection direction="up">
        <ContentSection>
          <SectionTitle>Key Team Members</SectionTitle>
          
          <TeamGrid>
            {teamMembers.map(member => (
              <TeamMemberCard key={member.id}>
                <MemberPhotoContainer>
                  <MemberPhoto 
                    style={{ backgroundImage: `url(${member.photo})` }}
                  />
                </MemberPhotoContainer>
                
                <MemberInfo>
                  <MemberName>{member.name}</MemberName>
                  <MemberTitle>{member.title}</MemberTitle>
                  <MemberBio>{member.bio}</MemberBio>
                </MemberInfo>
              </TeamMemberCard>
            ))}
          </TeamGrid>
        </ContentSection>
      </AnimatedSection>
    </>
  );
};

export default AboutTeam; 